module.exports = __webpack_public_path__ + "img/zhichengding.prt.c16b59ae.jpg";